export default __webpack_public_path__ + "6e4df84f2236572f505acd66159c1c33.svg";